import VertexShader from "./shaders/water.vs";
import FragmentShader from "./shaders/water.fs";

class WaterMaterial extends THREE.ShaderMaterial {
    constructor({
        normalSampler, mirrorSampler,
        alpha, time,
        distortionScale, textureMatrix,
        sunColor, sunDirection,
        eye, waterColor,
        side, fog,
        size
    }) {

        const uniforms = Object.assign({},
            THREE.UniformsLib.fog,
            THREE.UniformsLib.lights,
            {
                normalSampler: new THREE.Uniform(normalSampler),
                mirrorSampler: new THREE.Uniform(mirrorSampler),
                map: new THREE.Uniform(mirrorSampler),
                alpha: new THREE.Uniform(alpha),
                time: new THREE.Uniform(time),
                size: new THREE.Uniform(size),
                distortionScale: new THREE.Uniform(distortionScale),
                textureMatrix: new THREE.Uniform(textureMatrix),
                sunColor: new THREE.Uniform(new THREE.Color(sunColor)),
                sunDirection: new THREE.Uniform(new THREE.Vector3(sunDirection)),
                eye: new THREE.Uniform(eye),
                waterColor: new THREE.Uniform(new THREE.Color(waterColor))
            }
        );

        super({
            fragmentShader: FragmentShader,
            vertexShader: VertexShader,
            uniforms,
            transparent: true,
            lights: true,
            side,
            fog
        });
    }
}

export default WaterMaterial;
export { WaterMaterial };